import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


import { withAuthentication } from 'contexts/Session';
import { auth } from 'helpers/firebase';
import { ROLES } from "constants/user";


import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";

import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
import { getDashboard } from "helpers/routes";
import HomepageScreen from "views/Homepage/HomepageScreen";

const hist = createBrowserHistory();

class App extends Component {

  componentDidMount() {

    auth.onAuthStateChanged(currentUser => {
      if (currentUser) {
        console.log('currentUser: ', currentUser);
        this.props.createUserAction(currentUser);
        this.props.setCurrentUser(currentUser);
      }

      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.unsubscribe = this.props.getRoleAction();
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    return <Router history={hist}>
      <Switch>
        <Route path="/" component={HomepageScreen} exact />
        <Route path="/admin" component={AdminLayout} />
        <Route path="/auth" component={AuthLayout} />
      </Switch>
    </Router>
  }
}


const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
    currentRole: state.auth.currentRole
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  withAuthentication,
  connect(mapStateToProps, mapDispatchToProps)
)(App);